<template>
	<div class="pay_main">
		<div class="pay_main_body">
			<p class="countdown text-center">
				<van-count-down :time="countDownVal" @finish="orderCancel" @change="changeCountDownVal">
					<template #default="timeData">
						<span>请在</span>
						<span class="danger"
							>{{ timeData.minutes }}:{{timeData.seconds>9?timeData.seconds:'0'+timeData.seconds}}</span
						>
						<span>内完成支付，超时订单自动取消</span>
					</template>
				</van-count-down>
			</p>
			<div class="price_content text-center">
				<div class="price"><span>￥</span>{{ orderDetail.payPrice | priceFilter }}</div>
				<p class="title">{{ orderDetail.name }}</p>
			</div>
		</div>
		<div class="pay_type">
			<h3 class="title">支付方式</h3>
			<div class="list">
				<div class="item">
					<div class="icon">
						<img src="@/assets/icon/icon_wx_logo.png" alt="" />
					</div>
					<div class="content">
						<span>微信支付</span>
					</div>
					<div class="status">
						<img src="@/assets/icon/icon_success_mini.png" alt="" />
					</div>
				</div>
			</div>
		</div>
		<foot-button>
			<div class="pay_agree">
				<van-checkbox v-model="agreementChecked" shape="square"></van-checkbox>
				<p class="text">购买即视为同意<span class="primary">《服务包协议》</span></p>
			</div>
			<div class="pay_price">
				<span>合计：</span>
				<strong class="price_unit">￥</strong>
				<strong class="price_value">{{ orderDetail.payPrice | priceFilter }}</strong>
			</div>
			<van-button class="submit_btn" type="primary" @click="clickPay">立即支付</van-button>
		</foot-button>
	</div>
</template>

<script>
export default {
    name: 'payMain',
    data: () => ({
        curCountDownVal: '',
        agreementChecked: false,
        orderDetail: {},
        takeLeave: false // 是否主动离开
    }),
    computed: {
        countDownVal () {
            const totalTime = 15 * 60 * 1000
            if (!this.orderDetail.gmtCreate) return totalTime
            const createTime = this.$moment(this.orderDetail.gmtCreate).format('x')
            const poor = this.$store.state.account.serveDateTime - createTime
            return totalTime - poor
        },
        getPayResultUrl () {
            return `/order/detail/${this.$route.params.id}`
        }
    },
    created () {
        this.$utils.clearDialog()
        this.$store.dispatch('account/actionGetDateTime')
        this.getOrderDetail()
    },
    methods: {
        changeCountDownVal (countDown) {
            this.curCountDownVal = `${countDown.minutes}分${countDown.seconds}秒`
        },
        // 获取订单详情
        async getOrderDetail () {
            const res = await this.$api.order.getServiceDetail(this.$route.params.id)
            if (!res.code) {
                this.orderDetail = res.data
            }
        },
        // 点击立即支付
        clickPay () {
            if (!this.agreementChecked) {
                this.$toast('请先确认服务包协议')
                return
            }

            this.$wx.pay({
                id: this.$route.params.id,
                openid: this.$store.getters['account/getOpenid']
            }, () => {
                this.takeLeave = true
                this.$dialog({
                    title: '支付成功',
                    message: '可从订单记录中查看订单详情',
                    confirmButtonText: '知道了',
                }).then(() => {
                    this.$router.replace('/')
                })
            })
        },
        // 订单取消
        orderCancel () {
            this.takeLeave = true
            this.$router.replace(`${this.getPayResultUrl}`)
        }
    },
    beforeRouteLeave (to, from, next) {
        if (this.takeLeave) {
            next()
        } else {
            this.takeLeave = true
            this.$dialog.confirm({
                title: '提示',
                message: `订单已生成，请在${this.curCountDownVal}完成支付，否则系统将为您自动取消订单`,
                confirmButtonText: '继续支付',
                cancelButtonText: '确定离开'
            }).then(() => {
                this.takeLeave = false
                this.clickPay()
                this.$utils.clearDialog()
                next(false)
            }).catch(() => {
                next()
            })
        }
    }
}
</script>

<style scoped lang="less">
.pay_main {
	padding: 0 32px;
	.pay_main_body {
		padding-top: 50px;
		.price_content {
			padding: 27px 0;
			.price {
				font-family: PingFangSC-Semibold;
				font-size: 72px;
				font-weight: normal;
				color: #1f2329;
				> span {
					font-size: 48px;
				}
			}
			.title {
				font-family: PingFangSC-Medium;
				font-size: 32px;
				font-weight: normal;
				line-height: 42px;
				color: #1f2329;
				margin-top: 7px;
			}
		}
	}
	.pay_type {
		padding-top: 41px;
		.title {
			font-family: PingFangSC-Regular;
			font-size: 28px;
			font-weight: normal;
			color: @gray-9;
			padding-bottom: 24px;
		}
		.list {
			.item {
				border-radius: 20px;
				background-color: #fff;
				display: flex;
				justify-content: space-between;
				align-items: center;
				height: 121px;
				padding: 0 32px;
				.content {
					flex: auto;
					padding: 0 24px;
					font-family: PingFangSC-Medium;
					font-size: 32px;
					font-weight: normal;
					line-height: 43px;
					color: #000000;
				}
				.icon {
					flex: 0 0 46px;
					> img {
						width: 46px;
						height: 46px;
						vertical-align: middle;
					}
				}
				.status {
					flex: 0 0 38px;
					> img {
						width: 38px;
						height: 38px;
						vertical-align: middle;
					}
				}
			}
		}
	}
	.pay_agree {
		width: 100%;
		height: 100px;
		position: absolute;
		top: -70px;
		left: 0;
		padding: 0 32px;
		display: flex;
		align-items: center;
		font-family: PingFangSC-Regular;
		font-size: 24px;
		font-weight: normal;
		line-height: 29px;
		color: #bbbfc4;
		background-color: #fff;
		.text {
			height: 32px;
			line-height: 32px;
			padding-left: 16px;
		}
	}
	.pay_price {
		font-family: PingFangSC-Regular;
		font-size: 26px;
		font-weight: normal;
		line-height: 26px;
		letter-spacing: 0.85px;
		color: @gray-9;
		strong {
			color: #000;
			&.price_value {
				font-size: 44px;
			}
		}
	}
	.submit_btn {
		width: 236px;
	}
}
</style>

<style lang="less">
.pay_main {
	.pay_agree {
		.van-checkbox__icon.van-checkbox__icon--square {
			display: flex;
			align-items: center;
			justify-content: center;
			.van-icon.van-icon-success {
				font-size: 20px;
				box-sizing: border-box;
				width: 32px;
				height: 32px;
				line-height: 26px;
				border-radius: 8px;
				border-width: 4px;
			}
		}
	}
}
</style>
